import { Capacitor } from '@capacitor/core';

export function isNative(): boolean {
  return typeof Capacitor !== 'undefined' && typeof Capacitor.isNativePlatform === 'function' && Capacitor.isNativePlatform();
}

export async function requestNativePermission(): Promise<{ granted: boolean; state: string }> {
  if (!isNative()) return { granted: false, state: 'not_native' };
  try {
    const cap = await import('@capacitor-firebase/messaging');
    const result = await cap.FirebaseMessaging.requestPermissions();
    const granted = result?.receive === 'granted';
    return { granted, state: result?.receive || 'unknown' };
  } catch (e) {
    console.warn('requestNativePermission error', e);
    return { granted: false, state: 'error' };
  }
}

export async function getNativeToken(): Promise<string> {
  if (!isNative()) return '';
  try {
    const cap = await import('@capacitor-firebase/messaging');
    const res = await cap.FirebaseMessaging.getToken();
    return res?.token || '';
  } catch (e) {
    console.warn('getNativeToken error', e);
    return '';
  }
}

export async function addNativeMessageListener(cb: (msg: any) => void): Promise<any> {
  if (!isNative()) return null;
  try {
    const cap = await import('@capacitor-firebase/messaging');
    return cap.FirebaseMessaging.addListener('notificationReceived', (payload: any) => {
      const data = payload?.data || payload?.notification?.data || payload?.notification || payload;
      try {
        cb({ ...payload, data });
      } catch (e) {
        cb(payload);
      }
    });
  } catch (e) {
    console.warn('addNativeMessageListener error', e);
    return null;
  }
}

export function removeNativeListener(listenerRef: any) {
  try {
    if (!listenerRef) return;
    if (typeof listenerRef.remove === 'function') listenerRef.remove();
  } catch (e) {
    // ignore
  }
}

export default {
  isNative,
  requestNativePermission,
  getNativeToken,
  addNativeMessageListener,
  removeNativeListener,
};
